/**
 * Get currency configuration from WooCommerce global data.
 *
 * @since 1.0.0
 */

import { __ } from '@wordpress/i18n';

import type { PriceFormatOptions } from '../types';

/**
 * Window with WooCommerce settings.
 *
 * @since 1.0.0
 */
interface WindowWithWc extends Window {
  wc?: {
    wcSettings?: {
      currency?: {
        code?: string;
        precision?: number;
      };
    };
  };
}

/**
 * Get currency configuration from WooCommerce global data.
 *
 * @since 1.0.0
 *
 * @return Currency configuration or default values.
 */
export const getCurrencyConfig = (): PriceFormatOptions => {
  try {
    // Try to get currency config from WooCommerce global data
    const windowWithWc = window as WindowWithWc;
    const wcSettings = windowWithWc?.wc?.wcSettings?.currency;

    return {
      currency: wcSettings?.code ?? 'USD',
      locale: navigator?.language ?? 'en-US',
      minimumFractionDigits: wcSettings?.precision ?? 2,
      maximumFractionDigits: wcSettings?.precision ?? 2,
    };
  } catch {
    // Fallback to safe defaults
    return {
      currency: 'USD',
      locale: 'en-US',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };
  }
};
